// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"9d2e803a","787":"da3d98bc"}[chunkId] + ".chunk.js";
};